// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__exNuf","photoBlock":"Message_photoBlock__KcD8H","photoImg":"Message_photoImg__v74vj","photo":"Message_photo__Ge9tD"};